import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

import { Card } from "ui/Card";

import { NoContentIcon } from "fond/svg_icons";

export const CreateAccountPanel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Card
      title={<b>No content?</b>}
      description={
        <>
          <Typography variant="body1" fontWeight={500} mb={2}>
            It looks like you are not part of an account and have not been shared content.
          </Typography>
          <Typography variant="body1">Be the first to set up an account for your company so others can join.</Typography>
        </>
      }
      icon={<NoContentIcon style={{ alignSelf: "start" }} />}
      buttonText="Create account"
      onClick={() => {
        navigate("/createaccount");
      }}
    />
  );
};
